import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Blog = () => {
  const [posts, setPosts] = useState([]);

  // CUSTOM PODACI POVEZANI S TOČNIM ID-EVIMA
  const customData = {
    1313: {
      image: "/img/cheesecake.webp",
      description: "Imamo recept za najkremastiji cheesecake s limunom koji se ne peče.",
    },
    1308: {
      image: "/img/jagoda.webp",
      description: "Osjećaj ljeta u svakom zalogaju, savršena za tople dane.",
    },
    1302: {
      image: "/img/cokolada.jpeg",
      description: "Jednostavan recept za kremastu čokoladnu tortu koja topi srca.",
    },
  };

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await fetch(
          "https://wp1.edukacija.online/backend/wp-json/wp/v2/posts?categories=136&_embed"
        );
        if (!response.ok) {
          throw new Error(`Došlo je do greške: ${response.status}`);
        }
        const json = await response.json();
        setPosts(json);
      } catch (err) {
        console.error(err);
      }
    };

    fetchPosts();
  }, []);

  return (
    <section className="blog-section">
      <h2>Sweet Moments Blog</h2>
      <p>Recepti, ideje i novosti iz našeg slatkog kutka!</p>
      <div className="blog-grid">
        {posts.map((post) => {
          const custom = customData[post.id];

          return (
            <div className="blog-card" key={post.id}>
              <h3>{post.title.rendered}</h3>

              {/* Ako postoji custom slika, prikaži je */}
              {custom?.image && (
                <img
                  src={custom.image}
                  alt={post.title.rendered}
                  style={{ width: "100%", height: "200px", objectFit: "cover" }}
                />
              )}

              {/* Ako postoji opis, prikaži ga */}
              {custom?.description && <p>{custom.description}</p>}

              <Link to={`/blog/${post.id}`} className="read-more">
                Pročitaj više
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Blog;
